<script>
    import { db } from '~/firebase';

    export let id;
    export let answer;
    
    let isAnswering = false;

    $: response = answer || '';

    async function submit() {
        await db
            .ref(`questions/${id}`)
            .update({ answer: response, visible: true });
        window.location.reload();
    }

    async function remove() {
        if (!window.confirm("Are you sure you want to permanently delete this question?")) {
            return;
        }

        await db
            .ref(`questions/${id}`)
            .delete();
        window.location.reload();
    }
</script>

<style lang="scss">
    .flex {
        display: flex;

        > * {
            margin-right: 1rem;
        }
    }
</style>

{#if isAnswering}
    <form on:submit|preventDefault={submit}>
        <textarea bind:value={response}></textarea>
        <div>
            <button>Answer</button>
            <button type="button" on:click={remove}>Delete</button>
        </div>
    </form>

    <a href="javascript:void(0)" on:click={() => isAnswering = false}>Cancel</a>
{:else}
    <div class="flex">
        <a href="javascript:void(0)" on:click={() => isAnswering = true}>    
            {#if answer}
                Edit Response
            {:else}
                Respond
            {/if}
        </a>
        <a href="javascript:void(0)" on:click={remove}>Delete</a>
    </div>
{/if}
<hr>